import { render, staticRenderFns } from "./WorkflowListTable.vue?vue&type=template&id=66772702&scoped=true&"
import script from "./WorkflowListTable.vue?vue&type=script&lang=js&"
export * from "./WorkflowListTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowListTable.vue?vue&type=style&index=0&id=66772702&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66772702",
  null
  
)

export default component.exports